import React from "react";
import { Link } from "react-router-dom";
import "../styles/Home.scss";
import HomeImg from "../img/wits.jpg";
import BookCover from "../img/preserving-identity-cover.webp";


const Home = () => (
  <main className="home-page">
    {/* Hero Section */}
    <header className="hero-section">
      <h1 className="hero-title">Welcome to GAIC Lab</h1>
      <p className="hero-subtitle">Where Games, AI, and Culture Converge</p>
    </header>

    {/* Introduction Section */}
    <section className="intro-section" aria-labelledby="intro-title">
      <section className="intro-content">
        <figure>
          <img src={HomeImg} alt="Lab" className="intro-image" />
          <figcaption>GAIC Lab</figcaption>
        </figure>
        <section className="description">
          <h2 id="intro-title">
            The Games, Artificial Intelligence, and Culture Lab
          </h2>
          <p>
            Established in 2024, the GAIC Lab focuses on computational
            linguistics and Artificial Intelligence. Housed in the Digital Arts
            Department at Wits University, it serves as a hub for students
            interested in Game Design and Virtual Reality Tech, aiming to
            explore AI applications in cultural and indigenous domains.
          </p>
          <button className="cta-button">
            <Link
              to="https://gaiclab.co.za/projects"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                display: "inline-block",
                color: "#fff",
              }}
            >
              Learn More
            </Link>
          </button>
        </section>
      </section>
    </section>

    {/* Latest Research Section */}
    <section className="latest-section" aria-labelledby="latest-research-title">
      <h2 id="latest-research-title">Latest Research</h2>
      <section className="project-cards-container">
        <article className="project-card featured-research" aria-labelledby="project1-title">
          <div className="research-badge">Latest Journal</div>
          <h3 id="project1-title">
            Examining the factors influencing undergraduate students' use of
            digital arts playrooms in South African university game studies
            programs
          </h3>
          <p className="author">Dr Oluwarotimi Randle</p>
          <p>
            Integrating digital arts playrooms into education provides an
            innovative opportunity to explore digital arts playrooms as a
            creative learning environment. This study examines the factors
            influencing students' use and adoption of these spaces.
          </p>
          <button className="cta-button">
            <Link
              to="https://conf.ul.ac.za/aportal/index.php?Entity=Oluwarotimi%20Randle%20and%20Kayode%20Oyetade%20(60-71)"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                display: "inline-block",
                color: "#fff",
              }}
            >
              Read the Journal
            </Link>
          </button>
        </article>
      </section>
    </section>

    <section className="latest-section" aria-labelledby="released-book-title">
      <h2 id="released-book-title">New Book Release</h2>
      <article className="project-card published-book-card released-book-card" aria-labelledby="released-book-title">
        <div className="release-book-grid">
          <div className="release-book-cover">
            <img src={BookCover} alt="Preserving Identity and History With African Languages cover" />
          </div>
          <div className="release-book-copy">
            <h3>Preserving Identity and History With African Languages</h3>
            <p className="published-book-meta">
              Stella Bolanle Apata, Oluwatoyin Ajani, Oluwarotimi Randle | IGI Global | May 2026
            </p>
            <p>
              The new book explores how African languages preserve cultural identity,
              history, and community knowledge. It makes the case for safeguarding
              language heritage in the modern digital age.
            </p>
            <a
              href="https://www.igi-global.com/book/preserving-identity-history-african-languages/374224"
              target="_blank"
              rel="noopener noreferrer"
              className="published-book-link"
            >
              View Book
            </a>
          </div>
        </div>
      </article>
    </section>
  </main>
);

export default Home;
